import { render, staticRenderFns } from "./Restricted.vue?vue&type=template&id=639e6d93&scoped=true"
import script from "./Restricted.vue?vue&type=script&lang=js"
export * from "./Restricted.vue?vue&type=script&lang=js"
import style0 from "./Restricted.vue?vue&type=style&index=0&id=639e6d93&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e6d93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639e6d93')) {
      api.createRecord('639e6d93', component.options)
    } else {
      api.reload('639e6d93', component.options)
    }
    module.hot.accept("./Restricted.vue?vue&type=template&id=639e6d93&scoped=true", function () {
      api.rerender('639e6d93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/Restricted.vue"
export default component.exports